import React, { useEffect, useState } from 'react'
import { Checkbox, FormControlLabel } from '@material-ui/core'

import { FilterProps } from './types'

export const BooleanFilter = (props: FilterProps) => {
  const { label, defaultValue, onChange } = props
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    if (!defaultValue) {
      setValue(defaultValue)
    }
  }, [defaultValue])

  return (
    <FormControlLabel
      control={
        <Checkbox
          id={label}
          checked={value}
          onChange={() => {
            const newValue = !value
            setValue(newValue)
            onChange(newValue, newValue ? "1" : "0")
          }}
          value={value || ''}
        />
      }
      label={label}
    />
  )
}
